"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _OutsideEventBehavior = _interopRequireDefault(require("./OutsideEventBehavior"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _OutsideEventBehavior.default;
exports.default = _default;